import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { GlobalClaimCap } from 'app/models/dto/lead-assignment/global-claim-cap.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GlobalClaimCapReps } from 'ng2-app/models/dto/lead-assignment/global-claim-cap-reps.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalClaimCapDataService {

  constructor(
    private http: ApiHttpClient
  ) { }

  getGlobalClaimCapData(): Observable<GlobalClaimCap> {
    return this.http.get<GlobalClaimCap>(`${environment.API_URL}/lead-assignment-global-claim-cap-data`);
  }

  SetGlobalClaimCapReps(reps: GlobalClaimCapReps[]): Observable<GlobalClaimCap> {
    return this.http.put<GlobalClaimCap>(`${environment.API_URL}/lead-assignment-global-claim-cap-data`, reps);
  }
}
